
    import '/opt/buildhome/repo/packages/x/docs/react/faq.zh-CN.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"FAQ","toc":"menu","filename":"docs/react/faq.zh-CN.md","lastUpdated":1755482246000,"group":{"title":"其他","order":4},"order":2,"__autoDescription":true,"description":"以下整理了一些 Ant Design X 社区常见的问题和官方答复，在提问之前建议找找有没有类似的问题。此外亦可参考过往的 issues。"};